import React from "react";

type Props = {
  children?: React.ReactNode;
};

/**
 * Minimal TSX component to validate TS/TSX support in the existing pipeline.
 * Renders nothing and has no side effects.
 */
const TsxProbe: React.FC<Props> = () => null;

export default TsxProbe;
